export const CameraIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Camera",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path d="M16 10.5L22 7V17L16 13.5" />
      <path d="M14 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6Z" />
    </svg>
  );
};
